<template>
  <div class="payment-info-payment-period">
    <div class="payment-info-title-text">
      {{ $t('plans.paymentPeriod') }}
    </div>
    <div
      class="payment-period-select-wrapper"
    >
      <dolphin-select
        :options="periods"
        :custom-discount-options="true"
        :default="periods[0].value"
        @input="handlePeriodChange($event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DolphinSelect from "@/components/custom/DolphinSelect";
import { mapFields } from "vuex-map-fields";

export default {
  name: 'PaymentDialogProlongMonths',

  components: {
    DolphinSelect
  },

  props: {
    updatingPlan: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      updateAvailableDays: false,
      periods: []
    }
  },

  computed: {
    ...mapGetters({
      paymentInfo: 'plans/paymentInfo',
      profile: 'main/profile',
      paymentSummary: 'plans/paymentSummary'
    }),
    ...mapFields('plans', ['balance', 'invoice']),
  },

  watch: {
    'paymentSummary.availableDays': {
      handler () {
        if (this.updatingPlan) {
          this.filterPeriods()
        }
      }
    }
  },

  created () {
    if (this.updatingPlan) {
      this.filterPeriods()
    } else {
      this.setPeriods(1)
    }
  },

  methods: {
    handlePeriodChange (period) {
      this.paymentInfo.prolongMonths = period
    },

    filterPeriods () {
      let day = this.paymentSummary.availableDays
      let months = 1

      for (let i = 30; i <= 360; i = i + 30) {
        if (day >= i) {
          months++
        }
      }

      this.setPeriods(months)
    },

    setPeriods (months) {
      const periods = []

      for (let i = months; i <= 12; i++) {
        const text = i + ' ' + this.$tc('plans.prolongMonths.months', i).toLowerCase() // месяц, месяца, месяцев | month, months

        let discount = 0

        if (i >= 6 && i < 12) { // Discount 20% for 6 to 11-month period
          discount = 20
        } else if (i === 12) { // Discount 40% for 12-month period
          discount = 40
        }

        periods.push({
          value: i,
          text,
          discount
        })
      }

      if (
        this.updatingPlan &&
        this.paymentSummary.availableDays > 0
      ) {
        periods.unshift({
          value: 0,
          text: this.$t('plans.noProlong'),
          discount: 0
        })

        this.paymentInfo.prolongMonths = 0
      }

      if (!periods.find((elem) => elem.value === this.paymentInfo.prolongMonths)) {
        this.paymentInfo.prolongMonths = periods[0].value
      }

      this.periods = periods
    }
  }
}
</script>

<style>
.payment-period-select-wrapper {
  margin-top: 6px;
  height: 40px;
}

.payment-info-payment-period {
  margin-top: 24px;
}
</style>